
export default class WhoSplideAgencySectors {

	constructor() {
		this.splideAgencySectors()
	}


	splideAgencySectors() {

		var elms = document.getElementsByClassName( 'splide--agency-sectors' );

		for ( var i = 0; i < elms.length; i++ ) {

			const el = elms[ i ];

			var splide = new Splide( el );

			splide.mount();

			splide.on( 'move resize', () => {
				this.sync_card_heights( el );
			} );

			this.sync_card_heights( el ) ;
		}
	}

	// bind splide event & sync sectors title, desc, heights
	sync_card_heights( block ){

		let synced = [
			{
				'class' : 'wp-block-agency-sectors__sector-name',
				'height' : 0
			},
			{
				'class' : 'wp-block-agency-sectors__sector-excerpt',
				'height' : 0
			}
		] ;

		let cards = block.getElementsByClassName( 'wp-block-agency-sectors__link' );
		cards = Array.from(cards);

		// reset min-heights & get native height
		cards.forEach( ( card, i ) => {

			synced.forEach( ( item, i ) => {

				let elm = card.getElementsByClassName( item.class )[ 0 ];

				if ( elm ) {

					// reset min-height
					elm.style.minHeight = '0px';

					// get height
					let height = elm.offsetHeight;

					if ( ! synced[ i ].height || synced[ i ].height < height ) {
						synced[ i ].height = height;
					}
				}
			} );

		} );

		// populate heights

		cards.forEach( ( card, i ) => {

			synced.forEach( ( item, i ) => {

				let elm = card.getElementsByClassName( item.class )[ 0 ];
				if ( elm ) {
					elm.style.minHeight = synced[ i ].height + 'px';
				}
			} );

		} );

		// - -

	}

}